var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import Icon from '../../../common/UIToolKit/Icon.vue';
import Popper from 'popper.js';
import UiButton from './UiButton.vue';
var CogMenu = /** @class */ (function (_super) {
    __extends(CogMenu, _super);
    function CogMenu() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isOpen = false;
        _this.popper = null;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        _this.closeListener = null;
        return _this;
    }
    CogMenu.prototype.togglePopper = function () {
        var _this = this;
        if (this.isOpen) {
            return this.isOpen = false;
        }
        this.isOpen = true;
        this.popper = new Popper(this.$refs.cogMenu, this.$refs.cogPopper, { placement: 'bottom-end' });
        this.closeListener = function (evt) {
            if (!_this.$el.contains(evt.target)) {
                _this.close();
            }
        };
        document.addEventListener('click', this.closeListener);
    };
    CogMenu.prototype.close = function () {
        document.removeEventListener('click', this.closeListener);
        this.isOpen = false;
        this.$emit('close');
    };
    CogMenu.prototype.callAction = function (action) {
        action.action(this.entity);
        this.close();
    };
    CogMenu.prototype.callDelete = function () {
        this.delete(this.entity);
        this.close();
    };
    var _a;
    __decorate([
        Prop({ default: null }),
        __metadata("design:type", Object)
    ], CogMenu.prototype, "entity", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", typeof (_a = typeof Function !== "undefined" && Function) === "function" ? _a : Object)
    ], CogMenu.prototype, "delete", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", Array)
    ], CogMenu.prototype, "customActions", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", Boolean)
    ], CogMenu.prototype, "large", void 0);
    CogMenu = __decorate([
        Component({
            components: {
                UiButton: UiButton,
                Icon: Icon,
            },
        })
    ], CogMenu);
    return CogMenu;
}(Vue));
export default CogMenu;
